// src/locale/country.ts
var getSafeCountryName = ({ countryCode, locale }) => {
  try {
    const regionNames = new Intl.DisplayNames([locale], { type: "region" });
    return regionNames.of(countryCode.toUpperCase()) || countryCode;
  } catch (error) {
    return countryCode;
  }
};

export {
  getSafeCountryName
};
//# sourceMappingURL=chunk-TS3OQVVW.mjs.map